<template>
  <layout :title="$route.name" :options="options">
    <div class="expande-horizontal centraliza wrap">
      <!-- <h1 class="text-center fonte orange--text">Bem Vindo</h1> -->
      <!-- <v-flex
        xs12
        md12
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6 mb-6'"
      >
        <ChartSaldo />
      </v-flex> -->

      <!-- <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <Saldo />
      </v-flex>
      <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <SaldoSaques />
      </v-flex>
      <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <SaldoTotalInvestido />
      </v-flex>
      <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <SaldoTotalPago />
      </v-flex> -->
      <v-flex
        xs12
        md4
        class="pa-2"
        v-for="report in get_reports"
        :key="report._id"
      >
        <v-card
          elevation="3"
          class="pa-4 d-flex flex-column justify-space-between"
          style="border-radius: 16px; background: white;"
        >
          <!-- Ícone + Avatar -->
          <div class="d-flex justify-end">
            <v-avatar size="40" color="orange lighten-2">
              <v-icon dark>mdi-group </v-icon>
            </v-avatar>
          </div>

          <!-- Valor principal -->
          <div class="text-center">
            <h2 class="font-weight-bold mb-2 orange--text">
              {{ $helper.formataSaldo(report.valor) }}
            </h2>
            <h3 class="font-weight-medium grey--text text--darken-2">
              {{ report.nome }}
            </h3>
          </div>

          <!-- Rodapé com data -->
          <div class="mt-4 text-center grey--text text--darken-1" style="font-size: 0.85rem;">
            Atualizado {{ $moment(report.updated_at).format("DD/MM/YYYY [às] HH:mm") }}
          </div>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <div class="expande-horizontal centraliza">
          <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-2'">
            <TotalUsers />
          </v-flex>
        </div>
      </v-flex>

    </div>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Saldo from "./components/Saldo";
import SaldoDeIndicacao from "./components/SaldoDeIndicacao";
import PlanoDeCarreira from "./components/PlanoDeCarreira";
import Tokens from "./components/Tokens";
import Unilevel from "./components/Unilevel";
import Notificacoes from "./components/Notificacoes";
import ChartSaldo from "./components/ChartSaldo";
import Link from "./components/Link";
import PlanExpiresIn from "./components/PlanExpiresIn";
import TotalUsers from "./components/TotalUsers";
export default {
  components: {
    TotalUsers,
  },
  computed: {
    ...mapGetters(["getDashboard", "get_reports"])
  },
  methods: {
    ...mapActions([
      "listBalanceInvestment",
      "listBalanceToken",
      "listBalanceUnilevel",
      "listUnilevels",
      "list_reports"
    ])
  },
  created() {
    // this.listBalanceInvestment();
    // this.listBalanceToken();
    // this.listBalanceUnilevel();
    // this.listUnilevels();
    this.list_reports();
  }
};
</script>
